<div class="cal-date py-2 text-uppercase text-center">
  <p *ngIf="currentDate" class="mb-1 small font-weight-bold">
    {{getDayOfWeek(currentDate)}}
  </p>

  <h6 *ngIf="currentDate" class="navy-font mb-0" [attr.data-test-id]="'current-schedule-date'" [attr.data-test-value]="currentDate">
    {{getDate(currentDate)}}
  </h6>
</div>
